import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ChatSidecarService {
	private _isOpen$ = new BehaviorSubject<boolean>(false);
	private _isFullscreen$ = new BehaviorSubject<boolean>(false);
	private _openFresh$ = new Subject<void>();

	isOpen$ = this._isOpen$.asObservable();
	isFullscreen$ = this._isFullscreen$.asObservable();
	openFresh$ = this._openFresh$.asObservable();

	open(): void {
		this._openFresh$.next();
		this._isOpen$.next(true);
	}

	close(): void {
		this._isOpen$.next(false);
		this._isFullscreen$.next(false);
	}

	setOpen(value: boolean): void {
		this._isOpen$.next(value);
	}

	setFullscreen(value: boolean): void {
		this._isFullscreen$.next(value);
	}
}
